function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 57.5,
  cy: 57.5,
  r: 57.5,
  fill: "#181C20"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "empty-avatar_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 115,
  height: 115
}, /*#__PURE__*/React.createElement("circle", {
  cx: 57.5,
  cy: 57.5,
  r: 57.5,
  fill: "#181C20"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-avatar_svg__a)",
  fill: "#424E57"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 57.5,
  cy: 46,
  r: 20.444
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.722 102.222c0-14.114 11.442-25.555 25.556-25.555h20.444c14.114 0 25.556 11.441 25.556 25.555v49.834c0 14.114-11.442 25.555-25.556 25.555H47.278c-14.114 0-25.556-11.441-25.556-25.555v-49.834z"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 57.5,
  cy: 57.5,
  r: 56.5,
  stroke: "#181C20",
  strokeWidth: 2
});

var SvgEmptyAvatar = function SvgEmptyAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE1IiBoZWlnaHQ9IjExNSIgdmlld0JveD0iMCAwIDExNSAxMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjU3LjUiIGN5PSI1Ny41IiByPSI1Ny41IiBmaWxsPSIjMTgxQzIwIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjExNSIgaGVpZ2h0PSIxMTUiPgo8Y2lyY2xlIGN4PSI1Ny41IiBjeT0iNTcuNSIgcj0iNTcuNSIgZmlsbD0iIzE4MUMyMCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPGNpcmNsZSBjeD0iNTcuNTAwMSIgY3k9IjQ2IiByPSIyMC40NDQ0IiBmaWxsPSIjNDI0RTU3Ii8+CjxwYXRoIGQ9Ik0yMS43MjIyIDEwMi4yMjJDMjEuNzIyMiA4OC4xMDgzIDMzLjE2MzggNzYuNjY2NyA0Ny4yNzc3IDc2LjY2NjdINjcuNzIyMkM4MS44MzYxIDc2LjY2NjcgOTMuMjc3NyA4OC4xMDgzIDkzLjI3NzcgMTAyLjIyMlYxNTIuMDU2QzkzLjI3NzcgMTY2LjE3IDgxLjgzNjEgMTc3LjYxMSA2Ny43MjIyIDE3Ny42MTFINDcuMjc3N0MzMy4xNjM4IDE3Ny42MTEgMjEuNzIyMiAxNjYuMTcgMjEuNzIyMiAxNTIuMDU2VjEwMi4yMjJaIiBmaWxsPSIjNDI0RTU3Ii8+CjwvZz4KPGNpcmNsZSBjeD0iNTcuNSIgY3k9IjU3LjUiIHI9IjU2LjUiIHN0cm9rZT0iIzE4MUMyMCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgEmptyAvatar as ReactComponent };